import React from "react";
import { IUserTrainingCourseVideoSummary } from "src/@types/ImpiricaPlatformApi";
import styles from "./TrainingSummaryVideo.module.scss";
import { Icon } from "src/components/icons/Icon";
import { CircleCheck } from "lucide-react";

type TrainingSummaryVideosProps = {
	video: IUserTrainingCourseVideoSummary;
};

const TrainingSummaryVideo: React.FC<TrainingSummaryVideosProps> = ({
	video,
}) => {
	return (
		<div className={styles.container}>
			<p className={styles.title}>{video.name}</p>
			{video.complete && (
				<Icon icon={CircleCheck} size="lg" className={styles.icon} />
			)}
		</div>
	);
};

export default TrainingSummaryVideo;
